import { Chip, Grid, Typography } from '@mui/material';

interface Props {
	chip?: boolean;
	chipVariant?: 'filled' | 'outlined';
	marginLeft?: number | string;
	marginTop?: number | string;
	title: string;
	value: number | string;
}

const ProcessItem: React.FC<Props> = ({
	chip,
	chipVariant = 'outlined',
	marginLeft = 4,
	marginTop,
	title,
	value,
}) => (
	<Grid container alignItems="center" style={{ marginTop }}>
		<Grid item>
			<Typography color="#686868" fontFamily="Montserrat" fontSize={14} fontWeight={500}>
				{title}
			</Typography>
		</Grid>
		<Grid item style={{ marginLeft }}>
			{chip ? (
				<Chip
					label={value}
					style={{ fontFamily: 'Montserrat', fontSize: 12 }}
					variant={chipVariant}
				/>
			) : (
				<Typography color="#1A1233" fontFamily="Montserrat" fontSize={14} fontWeight={600}>
					{value}
				</Typography>
			)}
		</Grid>
	</Grid>
);

export default ProcessItem;
